(() => {
  const ROOT_SELECTOR = '#form-container-ref[data-sizing="form-wrapper"]';
  const HOST_SELECTOR = 'shopify-forms-embed, [id^="app-embed-container-"]';
  const STYLE_ID = 'yeechi-email-popup-styles';
  const watchedRoots = new WeakSet();
  const activeRoots = new Set();
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  const popupStyles = `
    [data-yeechi-popup-frame] {
      box-sizing: border-box !important;
      overflow: hidden !important;
    }

    [data-yeechi-popup-content][class*="_gridItemContent_"],
    [data-yeechi-popup-content] [class*="_gridItemContent_"] {
      box-sizing: border-box !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      height: 100% !important;
    }

    ${ROOT_SELECTOR} section[class*="_formHeader_"] {
      box-sizing: border-box !important;
      margin: 0 auto 26px !important;
      text-align: center !important;
      width: 100% !important;
    }

    ${ROOT_SELECTOR} section[class*="_formHeader_"] :is(h1, h2, h3, h4, h5, h6) {
      font-family: Georgia, "Times New Roman", serif !important;
      font-size: clamp(30px, 2.35vw, 34px) !important;
      font-weight: 400 !important;
      line-height: 1.15 !important;
      margin: 0 0 14px !important;
      text-align: center !important;
    }

    ${ROOT_SELECTOR} [data-yeechi-popup-copy] {
      margin: 0 auto !important;
      max-width: 340px !important;
      text-align: center !important;
    }

    ${ROOT_SELECTOR} [data-yeechi-popup-offer] {
      font-size: 18px !important;
      font-weight: 600 !important;
      line-height: 1.35 !important;
      margin: 0 0 10px !important;
    }

    ${ROOT_SELECTOR} [data-yeechi-popup-body] {
      font-size: 16px !important;
      font-weight: 400 !important;
      line-height: 1.45 !important;
      margin: 0 !important;
    }

    ${ROOT_SELECTOR} form[class*="_formFieldset_"] {
      gap: 11px !important;
    }

    ${ROOT_SELECTOR} input[type="email"],
    ${ROOT_SELECTOR} input[autocomplete="email"] {
      box-sizing: border-box !important;
      height: 56px !important;
      min-height: 56px !important;
    }

    ${ROOT_SELECTOR} button[type="submit"] {
      box-sizing: border-box !important;
      height: 56px !important;
      min-height: 56px !important;
    }

    ${ROOT_SELECTOR} button[data-yeechi-popup-cta] {
      align-items: center !important;
      display: flex !important;
      font-size: 0 !important;
      justify-content: center !important;
      padding-block: 0 !important;
    }

    ${ROOT_SELECTOR} button[data-yeechi-popup-cta]::before {
      content: "GET 10%OFF 🏷️";
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 1.2 !important;
    }

    @media screen and (min-width: 769px) {
      [data-yeechi-popup-frame] {
        border-radius: 14px !important;
        grid-template-areas: "image content" !important;
        grid-template-columns: 50% 50% !important;
        height: min(500px, calc(100svh - 48px)) !important;
        max-height: calc(100svh - 48px) !important;
        max-width: 92vw !important;
        width: 900px !important;
      }

      [data-yeechi-popup-image],
      [data-yeechi-popup-content] {
        height: 100% !important;
        min-height: 0 !important;
      }

      [data-yeechi-popup-image] {
        border-radius: 14px 0 0 14px !important;
        grid-area: image !important;
      }

      [data-yeechi-popup-content] {
        grid-area: content !important;
      }

      [data-yeechi-popup-content][class*="_gridItemContent_"],
      [data-yeechi-popup-content] [class*="_gridItemContent_"] {
        align-items: center !important;
        padding: 45px !important;
      }

      ${ROOT_SELECTOR} section[class*="_formHeader_"] {
        flex: 0 0 auto !important;
        max-width: 360px !important;
        width: 100% !important;
      }

      ${ROOT_SELECTOR} form[class*="_formFieldset_"] {
        max-width: 360px !important;
        width: 100% !important;
      }
    }

    @media screen and (max-width: 768px) {
      [data-yeechi-popup-frame] {
        border-radius: 12px !important;
        display: grid !important;
        grid-template-areas: "content" !important;
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-rows: auto !important;
        height: auto !important;
        max-height: calc(100svh - 24px) !important;
        max-width: 370px !important;
        min-height: 0 !important;
        width: 92vw !important;
      }

      ${ROOT_SELECTOR} > [class*="_formContainer_"][class*="_grid_"]
        > [class*="_gridItem_"]:not([class*="_gridItemContent_"]),
      [data-yeechi-popup-image] {
        display: none !important;
        height: 0 !important;
        min-height: 0 !important;
        overflow: hidden !important;
        visibility: hidden !important;
      }

      ${ROOT_SELECTOR} > [class*="_formContainer_"][class*="_grid_"]
        > [class*="_gridItemContent_"],
      [data-yeechi-popup-content] {
        display: block !important;
        grid-area: content !important;
        min-width: 0 !important;
        width: 100% !important;
      }

      [data-yeechi-popup-content][class*="_gridItemContent_"],
      [data-yeechi-popup-content] [class*="_gridItemContent_"] {
        padding: 34px 28px 30px !important;
      }

      ${ROOT_SELECTOR} section[class*="_formHeader_"] {
        margin-bottom: 24px !important;
      }

      ${ROOT_SELECTOR} section[class*="_formHeader_"] :is(h1, h2, h3, h4, h5, h6) {
        font-size: 28px !important;
        margin-bottom: 13px !important;
      }

      ${ROOT_SELECTOR} [data-yeechi-popup-offer] {
        font-size: 17px !important;
        margin-bottom: 9px !important;
      }

      ${ROOT_SELECTOR} [data-yeechi-popup-body] {
        font-size: 15px !important;
        line-height: 1.45 !important;
      }

      ${ROOT_SELECTOR} form[class*="_formFieldset_"] {
        gap: 10px !important;
      }
    }
  `;

  function ensureStyles(root) {
    if (root.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = popupStyles;
    root.appendChild(style);
  }

  function markLayout(wrapper) {
    const frame = wrapper.matches('[class*="_formContainer_"][class*="_grid_"]')
      ? wrapper
      : wrapper.closest('[class*="_formContainer_"][class*="_grid_"]') ||
        wrapper.querySelector('[class*="_formContainer_"][class*="_grid_"]');
    if (!frame) return;

    const gridItems = Array.from(frame.children).filter(
      (item) => item instanceof Element && String(item.className).includes('_gridItem_'),
    );
    const content =
      (wrapper.matches('[class*="_gridItem_"]') ? wrapper : wrapper.closest('[class*="_gridItem_"]')) ||
      gridItems.find((item) => String(item.className).includes('_gridItemContent_'));

    frame.setAttribute('data-yeechi-popup-frame', '');

    gridItems.forEach((item) => {
      item.removeAttribute('data-yeechi-popup-content');
      item.removeAttribute('data-yeechi-popup-image');

      if (item === content) {
        item.setAttribute('data-yeechi-popup-content', '');
        restoreDesktopImage(item);
      } else {
        item.setAttribute('data-yeechi-popup-image', '');
        toggleMobileImage(item);
      }
    });
  }

  function toggleMobileImage(item) {
    if (mobileQuery.matches) {
      if (!item.hasAttribute('data-yeechi-popup-mobile-hidden')) {
        item.setAttribute('data-yeechi-popup-original-display', item.style.getPropertyValue('display'));
        item.setAttribute(
          'data-yeechi-popup-original-display-priority',
          item.style.getPropertyPriority('display'),
        );
        item.setAttribute('data-yeechi-popup-original-hidden', item.hidden ? 'true' : 'false');
      }

      item.setAttribute('data-yeechi-popup-mobile-hidden', '');
      item.hidden = true;
      item.style.setProperty('display', 'none', 'important');
      return;
    }

    restoreDesktopImage(item);
  }

  function restoreDesktopImage(item) {
    if (!item.hasAttribute('data-yeechi-popup-mobile-hidden')) return;

    const display = item.getAttribute('data-yeechi-popup-original-display') || '';
    const priority = item.getAttribute('data-yeechi-popup-original-display-priority') || '';

    if (display) item.style.setProperty('display', display, priority);
    else item.style.removeProperty('display');

    if (item.getAttribute('data-yeechi-popup-original-hidden') !== 'true') item.hidden = false;

    item.removeAttribute('data-yeechi-popup-mobile-hidden');
    item.removeAttribute('data-yeechi-popup-original-display');
    item.removeAttribute('data-yeechi-popup-original-display-priority');
    item.removeAttribute('data-yeechi-popup-original-hidden');
  }

  function setCopy(wrapper) {
    const header = wrapper.querySelector('section[class*="_formHeader_"]');
    if (header) {
      const title = header.querySelector('h1, h2, h3, h4, h5, h6');
      const copy = header.querySelector('div[class*="_textBody_"]');

      if (title && title.textContent.trim() !== 'Stay close.') {
        title.textContent = 'Stay close.';
      }

      const currentOffer = copy?.querySelector('[data-yeechi-popup-offer]');
      const currentBody = copy?.querySelector('[data-yeechi-popup-body]');
      const copyIsCurrent =
        currentOffer?.textContent === 'Enjoy 10% off your first order.' &&
        currentBody?.textContent === '✦New pieces, stories, and little things worth keeping close✦';

      if (copy && !copyIsCurrent) {
        const offer = document.createElement('p');
        const body = document.createElement('p');

        offer.setAttribute('data-yeechi-popup-offer', '');
        offer.textContent = 'Enjoy 10% off your first order.';
        body.setAttribute('data-yeechi-popup-body', '');
        body.textContent = '✦New pieces, stories, and little things worth keeping close✦';
        copy.replaceChildren(offer, body);
        copy.setAttribute('data-yeechi-popup-copy', '');
      }
    }

    const submit = wrapper.querySelector('button[type="submit"]');
    if (submit) {
      submit.setAttribute('data-yeechi-popup-cta', '');
      submit.setAttribute('aria-label', 'GET 10%OFF 🏷️');
    }
  }

  function updatePopup(root) {
    const wrapper = root.querySelector(ROOT_SELECTOR);
    if (!wrapper) return;

    markLayout(wrapper);
    setCopy(wrapper);
  }

  function watchRoot(root) {
    if (!root || watchedRoots.has(root)) return;

    watchedRoots.add(root);
    activeRoots.add(root);
    ensureStyles(root);

    const refresh = () => updatePopup(root);
    new MutationObserver(refresh).observe(root, {
      childList: true,
      subtree: true,
    });
    refresh();
  }

  function scan() {
    document.querySelectorAll(HOST_SELECTOR).forEach((host) => watchRoot(host.shadowRoot));
  }

  function refreshResponsiveLayout() {
    activeRoots.forEach((root) => updatePopup(root));
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.setInterval(scan, 1000);
  mobileQuery.addEventListener?.('change', refreshResponsiveLayout);
  scan();
})();
